// extracted by mini-css-extract-plugin
export default {"container":"Jumbotron_container__DiGH5","title":"Jumbotron_title__elN0p","subtitle":"Jumbotron_subtitle__0bspd"};